module.exports = __webpack_public_path__ + "img/thumb_image8.e2a5b934.jpg";